import Vue from 'vue'
import Vuex from 'vuex'

import match from './modules/match'
import user from './modules/user'
import agency from './modules/agency'
import join from './modules/join'
import event from './modules/event'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { match, user, agency, join , event}
})

// document.addEventListener('click', evnt => store.commit('setEvent', evnt))
// window.addEventListener('resize', evnt => store.commit('setEvent', evnt))

export default store



// WEBPACK FOOTER //
// ./src/district/store/index.js